module.exports = __webpack_public_path__ + "media/images/cw_logo-abd0c8494644ab2b5b7d0010012b6761.png";